import { MONEY_STRING } from './constants.js';

export const formatCents = (number, dec, thouands, seperator) => {
    /*
        - Take a number and format it using a variety of symbols and deliminators
    */
    var n = number,
        decimals = isNaN((dec = Math.abs(dec))) ? 2 : decimals,
        thousandSep = thouands || ',',
        decimalSep = seperator || '.',
        negativeSign = n < 0 ? '-' : '',
        rawString = String(
            parseInt((n = Math.abs(Number(n) || 0).toFixed(decimals)))
        ),
        firstThousand =
            (firstThousand = rawString.length) > 3 ? firstThousand % 3 : 0;

    return (
        negativeSign +
        (firstThousand
            ? rawString.substr(0, firstThousand) + thousandSep
            : '') +
        rawString
            .substr(firstThousand)
            .replace(/(\d{3})(?=\d)/g, '$1' + thousandSep) +
        (decimals
            ? decimalSep +
              Math.abs(n - rawString)
                  .toFixed(decimals)
                  .slice(2)
            : '')
    );
};

export const formatCurrency = (template = '', cents = 0) => {
    /*
        Format the cents based on money format template string
    */
    if (template.indexOf('amount_no_decimals') > -1) {
        return formatCents(cents, 0);
    }
    if (template.indexOf('amount_with_comma_separator') > -1) {
        return formatCents(cents, 2, '.', ',');
    }
    if (template.indexOf('amount_no_decimals_with_comma_separator') > -1) {
        return formatCents(cents, 0, '.', ',');
    }
    if (template.indexOf('amount_no_decimals_with_comma_separator') > -1) {
        return formatCents(cents, 0, '.', ',');
    }
    if (template.indexOf('amount_with_apostrophe_separator') > -1) {
        return formatCents(cents, 2, "'");
    }
    if (template.indexOf('amount') > -1) {
        return formatCents(cents);
    }
    return cents;
};

export const formatTemplate = (template = '') => {
    /*
        Sanitizes the money format template of money strings
    */
    const priceTemplate = template.replace(
        /({{(?:[a-z_\s])+}})/i,
        MONEY_STRING
    );
    if (priceTemplate.length) {
        return `${priceTemplate}`;
    }
    return `${MONEY_STRING}`;
};

export default {
    formatCents,
    formatTemplate,
    formatCurrency
};
